<script setup lang="ts">
import { computed } from 'vue'
import type { QuizQuestionAnswerMatching } from '@/core/domain/quiz/QuizQuestionAnswer.ts'

const props = defineProps<{
  answer: QuizQuestionAnswerMatching
  order: number
}>()

const letters = 'abcdefghijklmnopqrstuvwxyz'.split('')
const prefixes = computed(() => {
  return { left: props.order, right: letters[props.order - 1] ?? '-' }
})
</script>

<template>
  <div class="flex flex-1 flex-col">
    <p class="w-full flex-1">Paire {{ order }}</p>

    <div class="flex flex-1 flex-row gap-2">
      <!-- LEFT -->
      <div
        class="flex flex-1 shrink flex-row justify-start rounded-lg border border-solid p-0"
        :class="$style.MatchingAnswer"
      >
        <div
          class="bg-surface-100 dark:bg-surface-700 border-surface-400 dark:border-surface-400 w-12 flex-initial rounded-l-lg border-r py-2 text-center"
          :class="$style.prefix"
        >
          <p>{{ prefixes.left }}</p>
        </div>
        <p class="flex-1 grow px-2 py-2">{{ answer.left.value }}</p>
      </div>
      <!-- RIGHT -->
      <div
        class="flex flex-1 flex-row justify-start rounded-lg border border-solid p-0"
        :class="$style.MatchingAnswer"
      >
        <div
          class="bg-surface-100 dark:bg-surface-700 border-surface-400 dark:border-surface-400 w-12 flex-initial rounded-l-lg border-r py-2 text-center"
          :class="$style.prefix"
        >
          <p>{{ prefixes.right }}</p>
        </div>
        <p class="flex-1 grow px-2 py-2">{{ answer.right.value }}</p>
      </div>
    </div>
  </div>
</template>

<style module>
.MatchingAnswer {
  border-color: var(--surface-400);

  p {
    cursor: default;
  }

  &.prefix {
    width: 50px;
    max-width: 30px;
    border-right: 1px solid black;
    padding-left: 4rem;
    background-color: var(--surface-900);
  }
}
</style>
